import { convertBulletTablestoMarkdown } from '@/lib/tableFormatter';

export type MessageContentStage = (content: string) => string;

export interface MessageContentProfile {
  name: string;
  sanitizeStages: MessageContentStage[];
  repairMarkdownStages: MessageContentStage[];
}

export interface NormalizeMessageContentOptions {
  sanitizeStages?: MessageContentStage[];
  repairMarkdownStages?: MessageContentStage[];
}

export const sanitizeMessageContent = (content: string): string =>
  content
    .replace(/\r\n?/g, '\n')
    .replace(/\u0000/g, '');

export const repairMarkdownContent = (content: string): string =>
  convertBulletTablestoMarkdown(content);

const runStages = (content: string, stages: MessageContentStage[]): string =>
  stages.reduce((currentContent, stage) => stage(currentContent), content);

export const createMessageContentProfile = (
  name: string,
  options: NormalizeMessageContentOptions = {}
): MessageContentProfile => ({
  name,
  sanitizeStages: [
    sanitizeMessageContent,
    ...(options.sanitizeStages ?? []),
  ],
  repairMarkdownStages: [
    repairMarkdownContent,
    ...(options.repairMarkdownStages ?? []),
  ],
});

export const userMessageProfile = createMessageContentProfile('userMessageProfile');

export const assistantMessageProfile = (
  options: NormalizeMessageContentOptions = {}
): MessageContentProfile => createMessageContentProfile('assistantMessageProfile', options);

export const normalizeMessageContentWithProfile = (
  content: string,
  profile: MessageContentProfile
): string => {
  if (!content) {
    return content;
  }

  const sanitizedContent = runStages(content, profile.sanitizeStages);
  return runStages(sanitizedContent, profile.repairMarkdownStages);
};

export const normalizeMessageContent = (
  content: string,
  options: NormalizeMessageContentOptions = {}
): string =>
  normalizeMessageContentWithProfile(
    content,
    createMessageContentProfile('defaultMessageProfile', options)
  );
